import React from "react"
import PropTypes from "prop-types"
import "./ModalSlideStyles.css"
import { Modal } from "react-bootstrap"
import "./ModalStyles.css"
export const _Modal = ({ direction, className, ...otherProps }) => {
	if (direction === "left") {
		className = className ? className + " left" : "left"
	} else if (direction === "right") {
		className = className ? className + " right" : "right"
	}
	return (<Modal {...otherProps} className={className} />)
}

_Modal.propTypes = {
	direction: PropTypes.string,
	className: PropTypes.string
}

_Modal.Header = Modal.Header
_Modal.Body = Modal.Body
_Modal.Footer = Modal.Footer
_Modal.Title = Modal.Title

export default _Modal



// WEBPACK FOOTER //
// ./src/components/Modal/Modal.jsx